import { _isLessOrEqual } from '@/helpers/bigNumber'

const Mb = 8 * 1024 * 1024

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return _isLessOrEqual(args[0], Mb)
  }
}
